import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://127.0.0.1:8000";
export const baseURL = "https://arcumov-backend.siglonet.com";

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
